import { showAlert } from '../zeta-widget/tools/alert-tool'
import { actions } from '../features/member-bill-slice';
import { changeStatus, queryBill, readBill } from '../features/member-bill.thunk';

const delaySearch = 500;
let timerSearch = null;

export function performSearch(dispatch, cond) {
  if (timerSearch) clearTimeout(timerSearch);
  timerSearch = setTimeout(() => {
    dispatch(queryBill(cond));
  }, delaySearch);
}

export function showSection(dispatch, section) {
  dispatch(actions.setActiveSection(section))
}

export function showSection_Detail(dispatch) {
  dispatch(actions.setActiveSection('detail'))
}

export function showSection_Search(dispatch) {
  dispatch(actions.setActiveSection('search'))
}

export function openDetail(dispatch, _id) {
  // console.info(actions);
  dispatch(readBill(_id))
  .then(result => {
    // console.info(result);
    if (result.error) {
      showAlert(result.error.message || result.error)
      return;
    }

    showSection_Detail(dispatch)

    // Toggle button
    if (document.querySelector('button[name=btnApprove') !== null) {
      if (result.payload.bill_status === 'A') {
        document.querySelector('button[name=btnApprove').classList.add('d-none');
      } else {
        document.querySelector('button[name=btnApprove').classList.remove('d-none');
      }
    }
  })
  .catch(err => {
    console.error(err);
    showAlert(err);
  });
}

export function updateStatus_Approve(dispatch, app_id) {
  dispatch(changeStatus({app_id, status: 'A'}))
  .then(result => {
    // console.info('After', result);
    if (result.error) {
      showAlert(result.error.message, 'danger');
      return;
    }

    if (result.payload && result.payload.ok) {
      openDetail(dispatch, app_id);
    }
  });
}

export function updateStatus_Reject(dispatch, app_id) {
  dispatch(changeStatus({app_id, status: 'X'}))
  .then(result => {
    // console.info('After Reject', result);
    if (result.error) {
      showAlert(result.error.message, 'danger');
      return;
    }

    if (result.payload && result.payload.ok) {
      openDetail(dispatch, app_id);
    }
  }); 
}
